import { useEffect } from 'react';

import { useConsentStatus } from '@/ampli';
import { initMetaPixel } from '@/utils/meta-pixel';

/**
 * Initialises the Meta Pixel once the user has accepted cookies. Consent status
 * reacts to both a returning consented visitor (resolved on mount) and a fresh
 * "Accept" click in `ConsentBanner`, so the pixel never loads without consent.
 */
const MetaPixel = () => {
  const isOptedIn = useConsentStatus() === 'optedIn';

  useEffect(() => {
    if (isOptedIn) {
      initMetaPixel();
    }
  }, [isOptedIn]);

  return null;
};

export default MetaPixel;
